import { Dialog, DialogContent } from "@tellescope/ui";
import type { CalendarEvent } from "@tellescope/types-models";
import { AppointmentDetailsContent } from "./AppointmentDetailsContent";

interface AppointmentDetailsDialogProps {
  event: CalendarEvent | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  allowCancel: boolean;
  rescheduleUrl?: string;
  hideVideoAfterMinutes?: number;
}

export const AppointmentDetailsDialog = ({
  event,
  open,
  onOpenChange,
  allowCancel,
  rescheduleUrl,
  hideVideoAfterMinutes,
}: AppointmentDetailsDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        {event && (
          <AppointmentDetailsContent
            event={event}
            onOpenChange={onOpenChange}
            allowCancel={allowCancel}
            rescheduleUrl={rescheduleUrl}
            hideVideoAfterMinutes={hideVideoAfterMinutes}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
